export class SchedulablesController extends Controller {
  connect() {
    this.executePreconnectLogic(this);
    this.executeConnectLogic()
  }

  executeConnectLogic() {}

  executePreconnectLogic(obj) {
    (this.preConnectFunctions || []).forEach(fn => fn(obj))
  }
}

export const makeSchedulable = klass => {
  addPreConnectFunction(klass.prototype, function(obj) { obj.showRepeatUpdatePrompt = obj.showRepeatUpdatePrompt.bind(obj) })
  klass.prototype.showRepeatUpdatePrompt = function(event) {
    event && event.preventDefault && event.preventDefault();
    App.Modal.open({
      content: this.repeatUpdatePromptTarget.innerHTML,
      overSlideOut: true
    });
  }
  Object.defineProperties(klass.prototype, {
    schedulableType: {
      get: function() {
        return this.data.get("schedulable-type");
      }
    },
    schedulableID: {
      get: function() {
        return this.data.get("schedulable-id");
      }
    },
    schedulableDateString: {
      get: function() {
        return this.data.get("schedulable-date")
      }
    }
  });
  return klass;
};

export const makeTimeAllocable = klass => {
  addPreConnectFunction(klass.prototype, function(obj) {
    obj.getTimeAllocContainerFrom          = obj.getTimeAllocContainerFrom.bind(obj);
    obj.replaceTimeAllocationContainerWith = obj.replaceTimeAllocationContainerWith.bind(obj);
  })
  klass.prototype.getTimeAllocContainerFrom          = function(url)      { App.Helpers.ajaxRequest({ url, successHandler: this.replaceTimeAllocationContainerWith.bind(this) }); }
  klass.prototype.replaceTimeAllocationContainerWith = function(response) { App.Helpers.replaceElement(this.element, response); }
  Object.defineProperties(klass.prototype, {
    timeAllocationURL: {
      get: function() {
        return this.data.get("time-allocator-content-url");
      }
    }
  })
  return klass;
}

const addPreConnectFunction = (obj, fn) => {
  obj.preConnectFunctions = (obj.preConnectFunctions || []).concat([fn])
}



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulable_helpers.js